import React from "react";

import { useTranslation } from "lib/i18n/use-translation";
import withRouter, { Router } from "utility/with-router";

import LogoAzureAd from "Assets/images/azure_ad.png";

import {
  AuthLayout,
  Heading,
  SSOButton,
  Subtitle,
} from "apps/user/common/components/auth-layout";

export type AutoStoreProps = {
  router: Router;
};

const AutoStore: React.FC<AutoStoreProps> = () => {
  const { t } = useTranslation(["auth"]);
  return (
    <AuthLayout variant="form">
      <Heading>{t("auth:autostore.heading")}</Heading>
      <Subtitle>{t("auth:autostore.subtitle")}</Subtitle>
      <SSOButton
        label={t("auth:autostore.signInAzure")}
        icon={LogoAzureAd}
        href={process.env.REACT_APP_SIGN_IN_WITH_AZURE_AD_URL || ""}
      />
    </AuthLayout>
  );
};

export default withRouter(AutoStore);
